// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","container":"Header_container__vI36D","mobile":"Header_mobile__PQoVg","tablet":"Header_tablet__jEKAj","desktop":"Header_desktop__iuexH"};